/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actionTypes';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';

export const tabValue = (value) => {
  return { type: actiontypes.TAB, payload: value };
};

export const createRebateErrorMsg = (value) => {
  return { type: actiontypes.CREATE_REBATE_ERROR_MSG, payload: value };
};

export const createFieldErr = (value) => {
  return { type: actiontypes.CREATE_FIELD_ERR, payload: value };
};

export const saveEnable = (value) => {
  return { type: actiontypes.CR_ENABLE_SAVE, payload: value };
};

export const createRebatePgmDetail = (value) => {
  return { type: actiontypes.CREATE_REBATE_PGM_DETAIL, payload: value };
};

export const clearCreateRbtRedux = () => {
  return { type: actiontypes.CLEAR_CREATE_RBT_REDUX };
};

export const defaultAuditCheck = (value) => {
  return { type: actiontypes.CR_DEFAULT_AUDIT, payload: value };
};

export const crcommentsData = (value) => {
  return { type: actiontypes.CR_COMMENTS_FLAG, payload: value };
};

export const getUseDefAuditsInd = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_USE_DEF_AUDIT, {
      claimRebateProgramCode: code,
    })
    .then((response) => {
      let value = response.data?.useDefAuditsInd[0]?.useDefAuditsInd;
      dispatch({
        type: actiontypes.CR_USE_DEF_AUDIT,
        payload: value,
      });
      let val = value === 1 ? true : false;
      dispatch(defaultAuditCheck(val));
    })
    .catch(() => dispatch({ type: actiontypes.CR_USE_DEF_AUDIT, payload: '' }));
};

export const getLastFrozenQtr = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_LAST_FROZEN_QTR, { rebateProgramCd: code })
    .then((response) => {
      dispatch({
        type: actiontypes.CR_LAST_FROZEN_QTR,
        payload: response.data?.data?.lastFrozenInvoiceQtr,
      });
    })
    .catch(() =>
      dispatch({ type: actiontypes.CR_LAST_FROZEN_QTR, payload: '' })
    );
};

export const getIntGridList = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    rpcParamTypeCdForFedRegPct: 'FED_REG_PCT',
    rpcParamTypeCdForFedFpPct: 'FED_FP_PCT',
    calcTypeCd: 'INT',
  };
  return axios
    .post(serviceEndPoint.REBATE_INT_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rebateProgramIntShareResponseVO?.[0];
      dispatch({ type: actiontypes.CR_INT_GRID_DATA, payload: data });
      dispatch({
        type: actiontypes.CR_COPY_INT_GRID_DATA,
        payload: JSON.stringify(data),
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.CR_INT_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.CR_COPY_INT_GRID_DATA, payload: '{}' });
    });
};

export const getGroupGridData = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    rpcParamTypeCdCmsRept: [
      'CMS_RPT_GROUP_NUM',
      'CMS_RPT_GROUP_NAME',
      'CMS_RPT_TITLE',
    ],
    rpcParamTypeCdCmsUtz: ['CMS_UTIL_GROUP_NUM', 'CMS_UTIL_GROUP_NAME'],
  };
  return axios
    .post(serviceEndPoint.REBATE_GROUP_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rebateProgramGroupVO?.[0];
      dispatch({ type: actiontypes.CR_GROUP_GRID_DATA, payload: data });
      dispatch({
        type: actiontypes.CR_COPY_GROUP_GRID_DATA,
        payload: JSON.stringify(data),
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.CR_GROUP_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.CR_COPY_GROUP_GRID_DATA, payload: '{}' });
    });
};

export const getCmsFreezeQtr = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_CMS_FREEZE_QTR, { rebateProgramCd: code })
    .then((response) => {
      dispatch({
        type: actiontypes.CR_CMS_FREEZE_QTR,
        payload: response.data?.data?.cmsFreezeQtrDisplay,
      });
    })
    .catch(() =>
      dispatch({ type: actiontypes.CR_CMS_FREEZE_QTR, payload: '' })
    );
};

export const getMaxQtrEnroll = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_MAX_QTR_ENROLL, { rebateProgramCd: code })
    .then((response) => {
      dispatch({
        type: actiontypes.CR_MAX_ENROLL_QTR,
        payload: response.data?.data?.maxFrozenQtrDisplay,
      });
    })
    .catch(() =>
      dispatch({ type: actiontypes.CR_MAX_ENROLL_QTR, payload: '' })
    );
};

export const createRebateProgramApi = (payloadData) => {
  return axios
    .post(`${serviceEndPoint.CREATE_REBATE_PROGRAM}`, payloadData)
    .then((response) => {
      if (response.data.status === '001') {
        return true;
      } else {
        return false;
      }
    })
    .catch((response) => {
      return false;
    });
};

export const getOverrideDefaultData = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_OVERIDE_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rebateProgramDefaultOverrideVO?.[0];
      dispatch({ type: actiontypes.CR_DEFAULT_OVERRIDE_DATA, payload: data });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.CR_DEFAULT_OVERRIDE_DATA, payload: {} });
    });
};

export const getEnrollGridData = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.EREBATE_ENROLL_GRID_LIST, {
      rebateProgramCd: code,
    })
    .then((response) => {
      let data = response.data?.rpcEnrollmentVO2;
      dispatch({ type: actiontypes.CR_ENROLL_GRID_DATA, payload: data });
      dispatch({
        type: actiontypes.CR_COPY_ENROLL_GRID_DATA,
        payload: JSON.stringify(data),
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.CR_ENROLL_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.CR_COPY_ENROLL_GRID_DATA, payload: '{}' });
    });
};

export const getRebatePgmDetail = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.VIEW_REBATE_PGM, values)
    .then((response) => {
      dispatch(createRebatePgmDetail(response.data?.data?.[0]));
    })
    .catch((response) => {
      dispatch(createRebatePgmDetail({}));
    });
};

// Audit Grid Data
export const getAuditGridList = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    testGroupCd: ['C', 'I'],
    testTypeCd: [
      'UNA',
      'RES',
      'AES',
      'SRA',
      'RLA',
      'STR',
      'IDC',
      'UNP',
      'RGR',
      'RGP',
      'RGL',
    ],
  };
  return axios
    .post(serviceEndPoint.REBATE_AUDIT_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rpcParamTestVO2;
      dispatch({ type: actiontypes.CR_AUDIT_GRID_DATA, payload: data });
      // dispatch({
      //   type: actiontypes.COPY_AUDIT_GRID_DATA,
      //   payload: JSON.stringify(data),
      // });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.CR_AUDIT_GRID_DATA, payload: {} });
      // dispatch({ type: actiontypes.COPY_AUDIT_GRID_DATA, payload: '{}' });
    });
};

export const getUnitTypeAuditGridList = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    testGroupCd: 'C',
    testTypeCd: 'UNT',
    codeDomainKey: 'UNIT_TYPE_CD',
  };
  return axios
    .post(serviceEndPoint.REBATE_UNIT_TYPE_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rpcParamTestVO2;
      dispatch({
        type: actiontypes.CR_UNIT_TYPE_AUDIT_GRID_DATA,
        payload: data,
      });
      // dispatch({
      //   type: actiontypes.COPY_UNIT_TYPE_DATA,
      //   payload: JSON.stringify(data),
      // });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.CR_UNIT_TYPE_AUDIT_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.CR_COPY_UNIT_TYPE_DATA, payload: '{}' });
    });
};
